import React from 'react'

function Rep_OPDReports() {
  return (
    <div>OPD Reports</div>
  )
}

export default Rep_OPDReports